import { Card, CardContent, CardHeader, Grid } from '@material-ui/core';
import LocationSelect from 'App/Vehicles/shared/LocationSelect';
import MaintenanceStatusSelect from 'App/Vehicles/shared/MaintenanceStatusSelect';
import React from 'react';

import { InputField } from 'Elements/Form';

export default function MaintenanceBasicInfo() {
  return (
    <Card elevation={1}>
      <CardHeader title="Huollon tiedot" />
      <CardContent>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <LocationSelect
              name="maintenance.location_id"
              disabled
              placeholder=""
            />
          </Grid>
          <Grid item xs={6}>
            <MaintenanceStatusSelect
              name="maintenance.maintenance_status_id"
              placeholder=""
              disabled
            />
          </Grid>
          <Grid item xs={6}>
            <InputField
              fullWidth
              name="maintenance.kilometer_gauge_at"
              variant="outlined"
              disabled
              margin="normal"
              InputLabelProps={{ shrink: true }}
            ></InputField>
          </Grid>
          <Grid item xs={6}>
            <InputField
              fullWidth
              name="maintenance.kilometer_increment"
              variant="outlined"
              disabled
              margin="normal"
              InputLabelProps={{ shrink: true }}
            ></InputField>
          </Grid>
          <Grid item xs={6}>
            <InputField
              fullWidth
              name="maintenance.external_id"
              variant="outlined"
              disabled
              margin="normal"
              InputLabelProps={{ shrink: true }}
            ></InputField>
          </Grid>
          <Grid item xs={6}>
            <InputField
              fullWidth
              name="maintenance.external_url"
              variant="outlined"
              disabled
              margin="normal"
              InputLabelProps={{ shrink: true }}
            ></InputField>
          </Grid>
          <Grid item xs={12}>
            <InputField
              fullWidth
              name="maintenance.external_error"
              variant="outlined"
              disabled
              margin="normal"
              InputLabelProps={{ shrink: true }}
            ></InputField>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
}
